import {request, HTTPError} from "../api";
import {type GridDocument, validateGridDocument} from "./document";

export type SavedGrid = {id: string; editPath: string; createdAt: string; document: GridDocument};
export class SnapshotRequestError extends Error {
  constructor(public status: number, message: string) {super(message);}
}
export function validateSavedGrid(value: any): SavedGrid {
  if (!value || !/^[a-f0-9]{64}$/.test(value.id) || value.editPath !== `/grid/${value.id}` || typeof value.createdAt !== "string") throw new Error("Invalid Grid snapshot response");
  validateGridDocument(value.document);
  return value;
}
async function gridRequest(path: string, options = {}): Promise<SavedGrid> {
  let value;
  try {value = await request(path, {...options, credentials: "include"});} catch (error) {
    if (error instanceof HTTPError && typeof error.data?.message === "string") {
      throw new SnapshotRequestError(error.status, `${error.data.message}${error.data.instanceId ? ` (${error.data.instanceId})` : ""}`);
    }
    throw error;
  }
  return validateSavedGrid(value);
}
export const loadGridSnapshot = (id: string, signal: AbortSignal) => gridRequest(`/api/v3/grids/${encodeURIComponent(id)}`, {signal});
export const saveGridSnapshot = (document: GridDocument, key: string) => gridRequest("/api/v3/grids", {method: "POST", headers: {"Idempotency-Key": key}, body: JSON.stringify({document})});
